module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('h1', [_vm._v("Acknowledgment")]), _vm._v(" "), _c('p', [_vm._v("I wish to express my heartfelt gratitude to Mrs. Gina Yarbrough, who spent untold hours editing this novel and enriching it with her constructive criticisms and suggestions. She has helped me elevate this novel to her exacting standards. I am also deeply indebted to Dr. Venugopal Menon, for giving me encouragement and useful suggestions throughout the process of writing this novel. My son, Saril Raghu, also deserves my appreciation; the last chapter, which made the ending more human, was added at his suggestion. My original plan was to end where Disney contacts Chou, with a proposal to use Max’s ability to travel through the universe for creating a ‘Disney Universe Travel’ venture.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0be8e4d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0